import qwest from 'qwest';

import User from '../models/user.jsx';

let AuthApi = {
  signIn(login, password) {
    return new Promise((resolve, reject) => {
      qwest.post('/Login', {
        login: login,
        password: password,
      })
        .then((xhr, response) => {
          if (response.success) {
            let user = User.fromApiFormat(response.data);

            resolve(user);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  acceptTOS() {
    let onSuccess = (xhr, response) => {
      if (response.success) {
        return response;
      }
      throw response;
    };

    let onError = () => {
      throw {
        code: -1,
        data: null,
        message: 'Unexpected Error Accepting TOS',
        success: false,
      };
    };

    return qwest.post('/User/AcceptTOS', {})
      .then(onSuccess, onError);
  },

  watchIntroVideo() {
    let onSuccess = (xhr, response) => {
      if (response.success) {
        return response;
      }
      throw response;
    };

    let onError = () => {
      throw {
        code: -1,
        data: null,
        message: 'Unexpected Error Watching Intro Video',
        success: false,
      };
    };

    return qwest.post('/User/WatchIntroVideo', {})
      .then(onSuccess, onError);
  },

  getCurrentUser() {
    let onSuccess = (xhr, response) => {
      if (response.success) {
        return User.fromApiFormat(response.data);
      }
      throw response;
    };

    let onError = () => {
      throw {
        code: -1,
        data: null,
        message: 'Unexpected Error',
        success: false,
      };
    };

    return qwest.get('/Login/me')
      .then(onSuccess, onError);
  },

  downgrade(branchID) {
    let onSuccess = (xhr, response) => {
      if (response.success) {
        return User.fromApiFormat(response.data);
      }
      throw response;
    };

    let onError = () => {
      throw {
        code: -1,
        data: null,
        message: 'Unexpected Error',
        success: false,
      };
    };

    return qwest.get(`/Login/Downgrade?branchID=${branchID}`)
      .then(onSuccess, onError);
  },

  toggleTitrationTestMode() {
    let onSuccess = (xhr, response) => {
      if (response.success) {
        return User.fromApiFormat(response.data);
      }
      throw response;
    };

    let onError = () => {
      throw {
        code: -1,
        data: null,
        message: 'Unexpected Error Wet Lab Testing Only Mode',
        success: false,
      };
    };

    return qwest.post('/User/ToggleTitrationTestMode', {})
      .then(onSuccess, onError);
  },

};

export default AuthApi;
